package org.braunequip.web.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.braunequip.web.util.Theme
import org.braunequip.web.styles.RespSplitContainer
import org.braunequip.web.styles.toSitePalette
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.js.Date

val FooterStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .backgroundColor(Theme.Secondary.rgb)
            .padding(topBottom = 2.5.cssRem, leftRight = 10.percent)
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
    }
}

val ContactDetailsContainer = CssStyle {
    base {
        Modifier
            .width(min(900.px, 100.percent - 1.cssRem))
            .gap(2.cssRem)

    }
}

val addressContactColumn = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(2.cssRem)
            .textAlign(TextAlign.Center)
            .fontSize(20.px)
    }
    Breakpoint.MD {
        Modifier
    }
}

val footerFocusedStyle = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .textAlign(TextAlign.Center)
    }
}

val hoursTitle = CssStyle {
    base {
        Modifier
            .padding(bottom = 50.px)
            .fontSize(1.6.cssRem)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(25.px)
            .padding(bottom = 25.px)
    }
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Column(FooterStyle.toModifier().then(modifier), horizontalAlignment = Alignment.CenterHorizontally) {

        Div(ContactDetailsContainer.toModifier()
            .then(RespSplitContainer.toModifier()).toAttrs()) {
            Column(addressContactColumn.toModifier().fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                SpanText("Information", footerFocusedStyle.toModifier().width(370.px))
                SpanText("Braun Equipment & Empire Group Unlimited, Inc.", Modifier.width(370.px))
                SpanText("P.O. Box 1269 Red Bluff, California, United States", Modifier.width(320.px))
                SpanText("Office: 530-214-7530", Modifier)
                Link(
                    path = "/employeeportal",
                    text = "Employee Portal",
                    modifier = Modifier.fontWeight(FontWeight.Bold).color(Colors.White),
                    variant = UncoloredLinkVariant.then(UndecoratedLinkVariant)
                )
            }
            Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                SpanText("Hours", footerFocusedStyle.toModifier().then(hoursTitle.toModifier()))
                officeHoursTable()
            }
        }


        Span(Modifier.padding(top = 4.cssRem).textAlign(TextAlign.Center).toAttrs()) {
            Text("Copyright © 2025 Empire Group Unlimited, Inc. - All Rights Reserved.")
        }


    }
}


/*
    Using Table to keep them neatly aligned, as done in OG site.
    Creating separate composable, not to messy up @Page function too much.
*/
@Composable
fun officeHoursTable() {
    Table(Modifier.fillMaxWidth().toAttrs()) {
        officeHoursRow("Mon", "9:00 am - 5:00 pm")
        officeHoursRow("Tue", "9:00 am - 5:00 pm")
        officeHoursRow("Wed", "9:00 am - 5:00 pm")
        officeHoursRow("Thu", "9:00 am - 5:00 pm")
        officeHoursRow("Fri", "9:00 am - 5:00 pm")
        officeHoursRow("Sat", "Closed")
        officeHoursRow("Sun", "Closed")
    }
}

@Composable
fun officeHoursRow(day: String, time: String) {
    val focused = if (isCurrentDayAbbreviation(day)) { Modifier.fontWeight(FontWeight.Bold).color(Theme.PrimaryGreen.rgb) } else { Modifier }
    Tr(attrs = tableStyle.toModifier().then(focused).toAttrs()) {
        Td() {
            P(hoursStyle.toAttrs()) {
                Text(day)
            }
        }
        Td() {
            P(hoursStyle.toAttrs()) {
                Text(time)
            }
        }
    }
}

val tableStyle = CssStyle {
    base {
        Modifier
            .textAlign(TextAlign.Center)
    }
    Breakpoint.MD {
        Modifier
            .textAlign(TextAlign.Center)
    }
}

val hoursStyle = CssStyle {
    base {
        Modifier
            .fontSize(20.px)
            .margin(0.px)
            .padding(topBottom = 2.px, leftRight = 0.px)
    }
}

fun isCurrentDayAbbreviation(dayAbbreviation: String): Boolean {
    val dayAbbreviations = listOf("Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat")
    val currentDayIndex = Date().getDay()
    val currentDayAbbreviation = dayAbbreviations[currentDayIndex]
    return currentDayAbbreviation.equals(dayAbbreviation, ignoreCase = true)
}